import { ARC_ENVIRONMENT } from './arc-env';
const ENV_TO_BRANCH = {
  dev: 'qa-18',
  staging: 'staging-18',
  prod: 'production'
};
export const ArcDefaultBranch = ENV_TO_BRANCH[ARC_ENVIRONMENT];